import { IApplicationState } from '../../types/redux';

export function selectIsWebview(state: IApplicationState) {
  return state.page.isWebview;
}

export const selectPushNotificationEnabled = (state: IApplicationState) => state.page.pushNotificationsAllowed;
export const selectPushSettingsModalOpened = (state: IApplicationState) => state.page.isPushSettingsModalOpened;

export const selectIsStickyFooterVisible = (state: IApplicationState) => state.page.stickyFooterVisible;
export const selectIsStickyScrollBtnVisible = (state: IApplicationState) => state.page.stickyScrollBtnVisible;
export const selectIsValuationFiltersModalOpened = (state: IApplicationState) =>
  state.page.isValuationFiltersModalOpened;
export const selectIsDesktop = (state: IApplicationState) => state.page.deviceType === 'desktop';
